module.exports = __webpack_public_path__ + "static/media/chip.38559b09.svg";